import { render, staticRenderFns } from "./3840da33-f8e7-4c3a-88c5-febd09528084.vue?vue&type=template&id=3168a8ec&scoped=true"
import script from "./3840da33-f8e7-4c3a-88c5-febd09528084.vue?vue&type=script&lang=ts"
export * from "./3840da33-f8e7-4c3a-88c5-febd09528084.vue?vue&type=script&lang=ts"
import style0 from "./3840da33-f8e7-4c3a-88c5-febd09528084.vue?vue&type=style&index=0&id=3168a8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168a8ec",
  null
  
)

export default component.exports